import { SxProps } from '@mui/material';

export const ShippingTableDataGridBoxSx: SxProps = {
  height: 'calc(100vh - 100px)',
  marginTop: 0,
  // Table border
  '& .MuiDataGrid-root': {
    border: '1px solid rgba(224, 224, 224, 1)',
    outline: 'none',
  },
  // Remove blue focus outlines
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none',
    },
  // Style for edited cells
  '& .edited-cell': {
    backgroundColor: 'rgba(249, 197, 77, 0.30)',
  },
  // Style for editable cells
  '& .editable-cell': {
    cursor: 'pointer',
  },
  // Style for tracking link cell
  '& .MuiDataGrid-cell[data-field="trackingLink"], & .MuiDataGrid-columnHeader[data-field="trackingLink"]': {
    paddingLeft: '0 !important',
  },
  // Style for selected rows - consolidated
  '& .MuiDataGrid-row.Mui-selected, & .selected-row': {
    backgroundColor: 'rgba(249, 197, 77, 0.12) !important',
    boxShadow: 'none !important',
    borderColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'rgba(249, 197, 77, 0.12) !important',
      boxShadow: 'none !important',
      borderColor: 'transparent !important',
    },
  },
  // Style for cell editing - enhanced to remove shadow and fix yellow border
  '& .MuiDataGrid-cell--editing': {
    boxShadow: 'none !important',
    border: '1px solid #131414 !important',
    backgroundColor: '#FFFFFF !important',
    '& .MuiInputBase-root': {
      height: '100%',
      padding: '0 16px',
      boxShadow: 'none !important',
      border: 'none !important',
    },
    '& .MuiInputBase-input': {
      padding: '0',
      height: '100%',
      boxShadow: 'none !important',
      border: 'none !important',
    },
    // Remove any focus styles that might cause the yellow border
    '&:focus, &:focus-within': {
      outline: 'none !important',
      border: '1px solid #131414 !important',
    },
    // Remove any pseudo-elements that might be causing the shadow
    '&::after, &::before': {
      display: 'none !important',
      boxShadow: 'none !important',
    },
  },
  // Style for the Tracking carrier column's Select component
  '& .carrier-column .MuiSelect-select': {
    lineHeight: '48px !important',
  },
  // Remove underlines from inputs
  '& .MuiInput-underline:before, & .MuiInput-underline:after': {
    display: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  // Remove the blue border that appears on cell focus
  '& .MuiDataGrid-cell:focus-within::after, & .MuiDataGrid-cell::after, & .MuiDataGrid-columnHeader:focus-within::after, & .MuiDataGrid-columnHeader::after':
    {
      border: 'none',
    },
  // Target the blue outline on hover
  '& .MuiDataGrid-cell:hover': {
    outline: 'none',
  },
  // Row hover styles - ensure no background change on hover
  '& .MuiDataGrid-row:hover, & .MuiDataGrid-row.Mui-hovered': {
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    borderColor: 'transparent !important',
  },
  // Change checkbox color to #131414
  '& .MuiCheckbox-root.Mui-checked': {
    color: '#131414 !important',
  },
  '& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root': {
    color: '#131414 !important',
  },
  '& .MuiDataGrid-checkboxInput.Mui-checked': {
    color: '#131414 !important',
  },
  '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked': {
    color: '#131414 !important',
  },
};
